import * as api from '../api/api';
import * as userApi from '../api/user';
import * as txnApi from '../api/transactions';
import { getAuthenticatedUser } from './auth';

export const fetchConversionRates = async () => {
    try {
        const response = await api.currencyConversionPair();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching currencies:', error);
        return [];
    }
};

export const fetchWallets = async () => {
    try {
        const response = await api.getAllWallets();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        return [];
    }
};

export const addWallets = async (currencyID, setLoading, setWalletSelect, toast, setIsEdited, dispatch) => {
    setLoading(true);
    try {
        const response = await api.addWallets(currencyID);
        // console.log(response.data)
        toast.success("Wallet Created Successfully", {
            toastId: "addWallet-success-toast",
            className: "custom-toast",
        });

        // fetchWallets();
        getAuthenticatedUser(dispatch);

        setWalletSelect('');
        setIsEdited(false);
        return true;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        toast.error(error.response.data.message || "Error Creating Wallet", {
            toastId: "addWallet-fail-toast",
        });
        return false;
    } finally {
        setLoading(false);
    }
};

export const initializeFunding = async ( credentials) => {
    try {
        const response = await txnApi.initiateFunding( credentials);
        // console.log(response.data)
        return response;
    } catch (error) {
        console.error('Error initializing funding:', error);
        throw error;
        // if(error.response) return error.response.data || error.response;
    }
};
export const updateTransactionProcess = async (ref_id, credentials) => {
    try {
        const response = await api.updateTransactionProcess(ref_id, credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error);
        return error;
    }
};
export const updateCanceledTransactionProcess = async (ref_id) => {
    try {
        const response = await api.updateCanceledTransactionProcess(ref_id);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error);
        return error;
    }
};



export const bankMoneyTransfer = async (credentials) => {
    try {
        const response = await txnApi.bankMoneyTransfer(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        throw error;
    }
};
export const transferFunds = async (credentials) => {
    try {
        const response = await txnApi.sendMoney(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        throw error;
    }
};
export const transferFundsSummary = async (credentials) => {
    try {
        const response = await txnApi.validateTransfer(credentials);
        return response.data.data;
    } catch (error) {
        console.error('Error retrieving transfer summary:', error);
        throw error;
    }
};
export const swapCurrencyPreview = async (credentials) => {
    try {
        const response = await txnApi.swapCurrencyPreview(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        throw error;
    }
};

export const swapCurrency = async (credentials) => {
    try {
        const response = await txnApi.swapCurrency(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        throw error;
    }
};


export const fetchRecipientDetails = async (recipientInput) => {
    try {
        const response = await txnApi.getRecipientDetails(recipientInput);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching country states:', error);
        throw error;
    }
};
export const fetchRecentRecipients = async () => {
    try {
        const response = await txnApi.getRecentRecipients();
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching country states:', error);
        throw error;
    }
};

export const verifyTransaction = async (credentials) => {
    try {
        const response = await txnApi.verifyTransaction(credentials);
        // console.log(response)
        return response;
    } catch (error) {
        console.error('Error fetching country states:', error.response.data);
        throw error;
    }
};

export const getTransactions = async (itemsPerPage, pageNumber) => {
    try {
        itemsPerPage = itemsPerPage || 10;
        pageNumber = pageNumber || 1;

        const response = await api.getTransactions(itemsPerPage, pageNumber);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
};

export const getTransactionDetails = async (params) => {
    try {
        const response = await txnApi.fetchSingleTransactions(params);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
}

export const fetchTransactions = async (itemsPerPage, pageNumber, start, end) => {
    try {
        itemsPerPage = itemsPerPage || 10;
        pageNumber = pageNumber || 1;

        const response = await txnApi.fetchTransactions(itemsPerPage, pageNumber, start, end);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
};

export const verifyBankAccount = async (credentials) => {
    try {
        const response = await txnApi.verifyBankAccount(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error verifying bank account:', error);
        throw error;
    }
}

export const verifyBankTransfer = async (credentials) => {
    try {
        const response = await txnApi.verifyBankTransfer(credentials);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error verifying bank transfer:', error);
        throw error;
    }
}

export const getFormattedAmount = (amount, maxFractionDigits) => 
  new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: maxFractionDigits,
}).format(amount);